import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import T from 'components/common/text/T';
import { isClinicUserSelector } from 'store/modules/user';
import { useShallowAppSelector } from 'store/hooks';
import { ISystemSetting, ISystemSettingCode } from 'lib/types/userTypes';
import CustomSpan from 'components/common/text/CustomSpan';

interface SystemSettingListContainerProps {
  machineSettingList: ISystemSetting[];
  onClick: (data: ISystemSetting) => void;
}

function SystemSettingListContainer({
  machineSettingList,
  onClick,
}: SystemSettingListContainerProps) {
  const {
    isClinicUser,
  }: {
    isClinicUser: boolean;
  } = useShallowAppSelector(state => ({
    isClinicUser: isClinicUserSelector(state),
  }));

  const [current, setCurrent] = useState<ISystemSettingCode>('LIST');

  const contentsList = [{ pageCode: 'LIST' }, { pageCode: 'SCAN_IOS' }];

  return (
    <StyledSystemSettingList data-component-name="SystemSettingList">
      <div className="systemSettingList__container">
        {machineSettingList.map((item: ISystemSetting, index: number) => {
          return (
            <div
              key={index}
              className="systemSettingList__item_box"
              onClick={() => {
                onClick(item);
              }}
            >
              <div className="systemSettingList__image_box">
                <img src={item.img} />
              </div>
              <div className="systemSettingList__label_box">
                <CustomSpan fontSize={16} fontColor="#00A4E3" fontWeight={500}>
                  <T>{item.textCode}</T>
                </CustomSpan>
              </div>
            </div>
          );
        })}
      </div>
    </StyledSystemSettingList>
  );
}
const StyledSystemSettingList = styled.div<{}>`
  /* width: 100%;
  height: 640px;
  border-radius: 15px;
  padding: 30px;
  background-color: #ffffff;
  position: relative; */
  .systemSettingList__container {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    row-gap: 20px;
    column-gap: 20px;
    .systemSettingList__item_box {
      width: 293px;
      height: 280px;
      background-color: #edf4fb;
      border-radius: 10px;
      border: 1px solid #e1e1e7;
      overflow: hidden;
      &:hover {
        border: 1px solid #00a4e3;
        cursor: pointer;
        .systemSettingList__image_box {
          border-bottom: 1px solid #00a4e3;
        }
      }
      .systemSettingList__image_box {
        width: 100%;
        height: 230px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border-radius: 0 0 10px 10px;
        border-bottom: 1px solid #e1e1e7;
      }
      .systemSettingList__label_box {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;
export default React.memo(SystemSettingListContainer);
